export default function setTagsList(state, action) {
  state.sidebar.tagsList = action.payload;
}
